import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../bl_libs/invokeApi";
import {use_e2ee} from "../utils/utils";


export const dqInsiderModules = {
    postData: (data) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        let requestObj = {
            path   : '/admin/dq_insider/modules/post',
            method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
        };
        requestObj['postData'] = { data };
        return invokeApi(requestObj, use_e2ee());
    },
    listData: () => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path   : '/admin/dq_insider/modules/list',
            method : 'GET', headers : { 'Authorization' : `Bearer ${token}` }
        }, use_e2ee());
    },
    preRemoveCheck: (id) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path   : '/admin/dq_insider/modules/pre_remove/' + id,
            method : 'GET', headers : { 'Authorization' : `Bearer ${token}` }
        }, use_e2ee());
    },
    deleteEntity: (id) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path   : '/admin/dq_insider/modules/remove/' + id,
            method : 'GET', headers : { 'Authorization' : `Bearer ${token}` }
        }, use_e2ee());
    },
    updateEntity: (id, data) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        let requestObj = {
            path   : '/admin/dq_insider/modules/update/' + id,
            method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
        };
        requestObj['postData'] = data;
        return invokeApi(requestObj, use_e2ee());
    }
}

export const getDQInsiderProfilesListService= (subscription_status, collection_method, search, page, limit) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/dq_insider/profiles/list',
        method : 'GET',
        headers : { 'Authorization' : `Bearer ${token}` },
        queryParams: {
            subscription_status,
            collection_method,
            search,
            page,
            limit
        }
    };
    return invokeApi(requestObj, use_e2ee());
}



export const createDQInsiderProfileService = (payload) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/dq_insider/profiles/create',
        method : 'POST',
        headers : { 'Authorization' : `Bearer ${token}` },
    };
    requestObj['postData'] = payload;
    return invokeApi(requestObj, use_e2ee());
};


export const updateDQInsiderProfileService = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/dq_insider/profiles/update/' + dq_insider_id,
        method : 'POST',
        headers : { 'Authorization' : `Bearer ${token}` },
    };
    requestObj['postData'] = {};
    return invokeApi(requestObj, use_e2ee());
};


// Grants/revokes permission for an insider to author free DQ showcase/
// template learning programs. Deliberately separate from
// updateDQInsiderProfileService above, which also activates the account and
// emails fresh login credentials — side effects this toggle must not trigger.
export const setTemplateCreatorFlagService = (dq_insider_id, is_template_creator) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/dq_insider/profiles/' + dq_insider_id + '/template_creator',
        method : 'POST',
        headers : { 'Authorization' : `Bearer ${token}` },
    };
    requestObj['postData'] = { is_template_creator };
    return invokeApi(requestObj, use_e2ee());
};


export const getDQInsiderProfileByIdService = (id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/dq_insider/profiles/get/' + id,
        method : 'GET',
        headers : { 'Authorization' : `Bearer ${token}` }
    };
    return invokeApi(requestObj, use_e2ee());
}


// ── White-label Branding (admin edits any workspace by dq_insider_id) ────────
// Endpoints return plain JSON and read a plain body, so these are sent without
// e2ee (same as the client branding service).
export const getDQInsiderBrandingService = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/admin/dq_insider/profiles/branding/get/' + dq_insider_id,
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    });
};

// Single branding endpoint: colors, inline logo upload (image_base64 + mime_type)
// and logo removal (logo_url: null) all go through one POST.
export const updateDQInsiderBrandingService = (dq_insider_id, {
    colors, fonts, font_uploads, custom_stylesheet, stylesheet_upload,
    logo_url, image_base64, mime_type,
} = {}) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const postData = {};
    if (colors !== undefined) postData.colors = colors;
    if (fonts !== undefined) postData.fonts = fonts;
    if (font_uploads !== undefined) postData.font_uploads = font_uploads;
    if (custom_stylesheet !== undefined) postData.custom_stylesheet = custom_stylesheet;
    if (stylesheet_upload !== undefined) postData.stylesheet_upload = stylesheet_upload;
    if (logo_url !== undefined) postData.logo_url = logo_url;
    if (image_base64 !== undefined) postData.image_base64 = image_base64;
    if (mime_type !== undefined) postData.mime_type = mime_type;
    return invokeApi({
        path: '/admin/dq_insider/profiles/branding/update/' + dq_insider_id,
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData,
    });
};


export const getInsiderProgramsAndAssessmentsService = (dq_module_codes) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/admin/dq_insider/learning_program/insider_programs_assessments',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };

    requestObj['postData'] = { dq_module_codes };
    return invokeApi(requestObj);
};

// ── Program Templates (DQ-authored showcase learning programs) ──────────────
// See src/docs/Template-Learning-Programs-Architecture.md (my-dq-api) §8.1.
export const programTemplates = {
    listData: (page, limit) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        const params = new URLSearchParams();
        if (page) params.set('page', page);
        if (limit) params.set('limit', limit);
        const qs = params.toString();
        return invokeApi({
            path: '/admin/dq_insider/templates/list' + (qs ? `?${qs}` : ''),
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },
    updateMeta: (code, payload) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path: '/admin/dq_insider/templates/meta/' + code,
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            postData: payload,
        });
    },
    getStatus: (code) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path: '/admin/dq_insider/templates/status/' + code,
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },
    setPublishStatus: (code, publish) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path: '/admin/dq_insider/templates/publish/' + code,
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            postData: { publish },
        });
    },
    archive: (code) => {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
        return invokeApi({
            path: '/admin/dq_insider/templates/archive/' + code,
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },
};